import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Tool } from '@cyborg-monorepo/hunter/common';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ToolService {
  constructor(private httpClient: HttpClient) {}

  private apiUrl: string = environment.api + '/v2';

  public createTool(tool: Partial<Tool>): Observable<Tool> {
    return this.httpClient.post<Tool>(`${this.apiUrl}/tool/`, tool);
  }

  public getToolById(id: string): Observable<Tool> {
    return this.httpClient.get<Tool>(`${this.apiUrl}/tool/${id}`);
  }

  public updateTool(id: string, toolData: Partial<Tool>): Observable<Tool> {
    return this.httpClient.put<Tool>(`${this.apiUrl}/tool/${id}`, toolData);
  }

  public deleteTool(id: string): Observable<void> {
    return this.httpClient.delete<void>(`${this.apiUrl}/tool/${id}`);
  }
}
